import { AuthService } from './../services/auth.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';
import {MessageService} from '../message.service';

@Injectable()
export class AuthGuard implements CanActivate {


  constructor(private msg:MessageService,private _authService: AuthService, private _router: Router) {
  
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
 
     
       localStorage.setItem('state',state.url);
       localStorage.setItem('qr',JSON.stringify(next.queryParams));

    
 
       return this._authService.isBoolAuthenticated();






      //  return  this._authService.isAuthenticated().subscribe(e => {
       

      //        if(e.status==false || e.status=='error'){
        
      //        this._router.navigate(['/login']);

      //        return false;

      //        } else{


      //         this.msg.sendMessage({'user':e.user,'type':'left_menu_link','navigations':e.navigation})
                    

              
      //        }

            
                  
              

      //       }); 

            //return true;


   
 
  }

}
